// Coloration syntaxique JSON minimale, sans dépendance (aucune lib de
// highlighting dans package.json) -- tokenizeJSON/classifyToken sont des
// fonctions pures (pas de React ici), testables isolément et réutilisables
// depuis n'importe quel contexte. Le rendu React (mapping token -> <span>)
// vit dans les composants qui l'utilisent (ui.js/CJDropshippingViewModal.js),
// pas ici, pour garder ce module 100% pur/portable.

// Capture soit une chaîne JSON (avec ses guillemets échappés correctement),
// soit true/false/null, soit un nombre. Le groupe 2 capture ":" (+espaces)
// quand la chaîne est suivie d'un deux-points -- ça permet de distinguer une
// clé d'une valeur-chaîne sans jamais confondre les deux.
const JSON_TOKEN_REGEX = /("(?:\\u[0-9a-fA-F]{4}|\\[^u]|[^\\"])*")(\s*:)?|\btrue\b|\bfalse\b|\bnull\b|-?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?/g;

const classifyToken = (token, isKey) => {
  if (isKey) return "cjds-json-key";
  if (token === "true" || token === "false") return "cjds-json-bool";
  if (token === "null") return "cjds-json-null";
  if (/^-?\d/.test(token)) return "cjds-json-number";
  return "cjds-json-string";
};

/**
 * Découpe une chaîne JSON.stringify(data, null, 2) en tokens classés :
 * [{text, className}, ...] -- className est null pour la ponctuation/les
 * espaces non colorés (accolades, crochets, virgules).
 */
const tokenizeJSON = (jsonString) => {
  const input = String(jsonString ?? "");
  const tokens = [];
  let lastIndex = 0;
  let match;
  JSON_TOKEN_REGEX.lastIndex = 0;
  while ((match = JSON_TOKEN_REGEX.exec(input)) !== null) {
    const [full, stringLiteral, colonSuffix] = match;
    const offset = match.index;
    if (offset > lastIndex) {
      tokens.push({ text: input.slice(lastIndex, offset), className: null });
    }
    const isKey = Boolean(stringLiteral && colonSuffix);
    const valueText = isKey ? stringLiteral : full;
    tokens.push({ text: valueText, className: classifyToken(stringLiteral || full, isKey) });
    if (isKey) {
      tokens.push({ text: colonSuffix, className: null });
    }
    lastIndex = offset + full.length;
  }
  if (lastIndex < input.length) {
    tokens.push({ text: input.slice(lastIndex), className: null });
  }
  return tokens;
};

module.exports = { tokenizeJSON, classifyToken, JSON_TOKEN_REGEX };
